<script>
import FormFilter from './FormFilter.vue';

export default {
  name: 'FormFilterGroup',
  components: {
    FormFilter,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    filters: {
      type: Array,
      required: true,
    },
    groups: {
      type: Array,
      required: true,
    },
    metrics: {
      type: Object,
      required: true,
    },
  },
  data: function() {
    return {
      isClosed: false,
    };
  },
  methods: {
    filterChange: function(filter, metric, value, range) {
      this.$emit('filterChange', filter, metric, value, range);
    },
    filtersByGroup: function(groupId) {
      return this.filters.filter(filter => filter.group.id === groupId);
    },
    metricsByGroup: function(groupId) {
      const allMetrics = Array.from(Object.values(this.metrics));
      const groupFilters = this.filtersByGroup(groupId);
      const groupMetrics = groupFilters.reduce((groupMetrics, filter) => [...groupMetrics, ...filter.metrics], []);

      return allMetrics.filter(metric => groupMetrics.includes(metric.id));
    },
    toggle: function() {
      this.isClosed = !this.isClosed;
    },
  },
};
</script>
<template>
  <fieldset :class="{ closed: isClosed, 'form-finder__setting-field': true }">
    <h5 @click="toggle">{{ name }}
      <svg width="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M12.682 4.018c.3 0 .5.1.7.3.4.4.4 1 0 1.4l-4.5 4.5 4.5 4.5c.4.4.4 1 0 1.4-.4.4-1 .4-1.4 0l-6-6 6-6c.2 0 .4-.1.7-.1" fill="#333732"/></svg>
    </h5>
    <FormFilter
      v-for="group in groups"
      :key="group.id"
      :fields="filtersByGroup(group.id)"
      :metrics="metricsByGroup(group.id)"
      :name="group.name"
      @filterChange="filterChange"
    />
  </fieldset>
</template>
